var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Header extends Component {
    constructor() {
        super('Header', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if (!$('body').hasClass('home'))
                return;
            const headerReduced = sessionStorage.getItem('headerReduced');
            if (headerReduced === 'true') {
                $('body').removeClass('home');
            }
            else {
                $('.header').on('click', () => {
                    if ($('.header').hasClass('reduced'))
                        return;
                    this.reduceHeader();
                });
                this.timeoutID = window.setTimeout(() => {
                    this.reduceHeader();
                }, 2500);
            }
            this.success();
        });
    }
    reduceHeader() {
        clearTimeout(this.timeoutID);
        sessionStorage.setItem('headerReduced', 'true');
        $('.header').addClass('reduced');
        $('.header a:not(.header-logo), .mobile-button-container').addClass('transparent');
        let step = 0;
        let intervalID;
        setTimeout(() => {
            this.revealHeader(step);
            intervalID = window.setInterval(() => {
                step++;
                if (step === $('.header a:not(.header-logo)').length) {
                    clearInterval(intervalID);
                    return;
                }
                this.revealHeader(step);
            }, 100);
        }, 500);
    }
    revealHeader(step) {
        $('.mobile-button-container').removeClass('transparent');
        $('.header a:not(.header-logo)').eq(step).removeClass('transparent');
    }
}
